import { useDropzone } from 'react-dropzone';

import { IMAGE_UPLOAD_CONSTANTS } from '@/views/build/constant';
import { useConfirmImageReplace } from '@/views/build/hook/useConfirmImageReplace';

export const useDroppableImageUpload = ({
  onUploadStart,
  imageUrl,
  multiple = false,
}: {
  onUploadStart: (files: File[]) => void;
  imageUrl?: string;
  multiple?: boolean;
}) => {
  const { confirm } = useConfirmImageReplace();

  const { getRootProps, getInputProps, isDragActive, inputRef } = useDropzone({
    onDrop: (files: File[]) => {
      void (async () => {
        if (files.length === 0) return;
        if (multiple || !imageUrl) {
          onUploadStart(multiple ? files : [files[0]]);
          return;
        }
        const shouldReplaceImage = await confirm();
        if (!shouldReplaceImage) return;
        onUploadStart([files[0]]);
      })();
    },
    noClick: true,
    noKeyboard: true,
    multiple,
  });

  return {
    rootProps: { ...getRootProps() },
    inputProps: {
      ...getInputProps(),
      accept: IMAGE_UPLOAD_CONSTANTS.ALLOWED_IMAGE_EXTENSIONS.map(
        extension => `image/${extension}`,
      ).join(','),
    },
    isDragActive,
    inputRef,
  };
};
